import { apiGet, apiPost, apiDelete, apiPutMultipart } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import * as notificationsActions from './notificationActions';

export function getParcelStats() {
  const route = '/landlords/parcel_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PARCELS::FETCH_PARCEL_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_PARCELS::SAVE_PARCEL_STATS',
          payload: response.detailed_parcels_counts,
        });
      }),
    });
  };
}

export function getFilteredParcels(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PARCELS::FETCH_PARCELS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_parcels?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(showParcels(response.parcels, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showParcels(response, timestamp, offset) {
  return {
    type: 'LANDLORD_PARCELS::SHOW_PARCELS',
    parcels: response,
    timestamp,
    offset,
  };
}

export function getParcelDetails(parcelID) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/parcels/${parcelID}`)
        .done(response => {
          dispatch(showParcelDetails(response.parcel));
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getParcelDetailsForKiosk(parcelID) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/kiosk_parcels/${parcelID}`)
        .done(response => {
          dispatch(showParcelDetails(response.parcel));
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showParcelDetails(parcelDetails) {
  return {
    type: 'LANDLORD_PARCELS::SAVE_PARCEL_DETAILS',
    parcelDetails,
  };
}

export function getUniqueParcelUID() {
  return dispatch => {
    return dispatch({
      type: 'postUniqueParcelUID',
      payload: apiPost(Auth.getApiUrl() + `/landlords/parcels/unique_ids`)
        .done(response => {
          return response.unique_parcel_id;
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function releaseParcels(data, parcelIds) {
  return dispatch => {
    return dispatch({
      payload: parcelPayload(data, parcelIds)
        .done(response => {
          return dispatch(notificationsActions.showSuccess('parcelSuccessfullyReleased'));
        })
        .catch(error => {
          dispatch(notificationsActions.showFailure(error));
          console.error('request failed', error);
          return error;
        }),
    });
  };
}

export function createOrUpdateParcel(data, parcelId) {
  let successVerbiage = 'Parcel Successfully Added';
  if (parcelId) {
    successVerbiage = 'Parcel Successfully Updated';
  }

  return dispatch => {
    return dispatch({
      payload: parcelPayload(data, parcelId)
        .done(response => {
          dispatch(notificationsActions.showSuccess(successVerbiage));
        })
        .catch(error => {
          dispatch(notificationsActions.showFailure(error));
          console.error('request failed', error);
          throw Error;
        }),
    });
  };
}

function parcelPayload(data, parcelIds) {
  if (parcelIds) {
    const multiPartFormData = new FormData();

    if (data) {
      multiPartFormData.append('signature', data);
    }

    multiPartFormData.append('parcel_uuids', JSON.stringify(parcelIds));

    return apiPutMultipart(Auth.getApiUrl() + `/landlords/release_parcels`, multiPartFormData);
  } else {
    data.unit_id = data.unit_selected.value;
    data.recipient_id = data.tenant.value;
    return apiPost(Auth.getApiUrl() + '/landlords/parcels', data);
  }
}

export function deleteParcel(parcelId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/parcels/${parcelId}`)
        .done(response => {
          dispatch(notificationsActions.showSuccess('parcelSuccessfullyDeleted'));
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function saveSignature(signature) {
  return {
    type: 'LANDLORD_PARCELS::SAVE_SIGNATURE',
    signature,
  };
}
